'use strict';

/*
  How to use it:

  1) Your controller should have this.$mdToast
  2) Import this thing:
    import SimpleMessages from './simple-messages';
  3) Assign it to your controller's prototype:
    Object.assign(OperationProcedureController.prototype, SimpleMessages);
*/

const SimpleMessages = {
  simpleSuccess(msg, hideDelay) {
    if (!this.$mdToast) {
      return;
    }
    if (!msg) msg = `Operación completada con éxito`;
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'success',
        hideDelay: hideDelay || 2500,
        textContent: msg
      })
    );
  },

  simpleError(msg, hideDelay) {
    if (!this.$mdToast) {
      return;
    }
    if (!msg) msg = `Ocurrió un error`;
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'error',
        hideDelay: hideDelay || 2500,
        textContent: msg
      })
    );
  }
};

export default SimpleMessages;
